
<template>
  <div>
    <el-form
      label-position="right"
      label-width="80px"
    >
      <el-row :gutter="20">
        <el-col :span="10">
          <el-form-item label="地区">
            <el-cascader
              v-model="selectedArea"
              :options="areaData"
              :props="{ expandTrigger: 'hover' }"
              placeholder="请选择地区"
              @change="handleAreaChange"
            />
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="单位">
            <el-select
              v-model="selectedDanWeiKey"
              clearable
              placeholder="请选择单位"
              @change="handleGetMainData()"
            >
              <el-option
                v-for="item in danweiData"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          :span="4"
          style="align:center"
        >
          <el-button
            type="primary"
            @click="handleAddLevel1"
          >
            新增
            <i class="el-icon-plus el-icon--right" />
          </el-button>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-tree
            :data="unitData"
            node-key="id"
            default-expand-all
            :expand-on-click-node="false"
          >
            <span
              slot-scope="{ node,data }"
              class="custom-tree-node"
            >
              <span>{{ node.label }}{{ data.spareStr02?('('+data.spareStr02+')'):'' }}</span>
              <span>
                <el-button
                  type="text"
                  size="mini"
                  @click="() => handleViewMember(node,data)"
                >成员</el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="() => handleAddNode(node,data)"
                >增加</el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="() => handleEditNode(node,data)"
                >编辑</el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="() => handleDelNode(data)"
                >删除</el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="() => handleAddMaster(node,data)"
                >负责人</el-button>
              </span>
            </span>
          </el-tree>
        </el-col>
        <el-col :span="14">
          <el-card v-if="editFormShow">
            <el-form
              ref="entityData"
              label-position="right"
              :rules="rules"
              label-width="100px"
              :model="entityData"
            >
              <el-form-item label="上级部门">
                {{ entityData.parentName }}
              </el-form-item>
              <el-form-item
                label="科研团队"
                prop="showName"
              >
                <el-input v-model="entityData.showName" />
              </el-form-item>
            </el-form>
            <el-row>
              <el-col>
                <el-button
                  type="primary"
                  @click="handleSave"
                >
                  保存
                </el-button>
                <el-button @click="editFormShow=false">
                  取消
                </el-button>
              </el-col>
            </el-row>
          </el-card>
          <el-card v-if="memberShow">
            <div slot="header" class="clearfix">
              <span>{{ bumenFullName }}</span>
            </div>
            <el-table
              :data="memberData"
              style="width: 100%"
            >
              <el-table-column
                prop="userName"
                label="姓名"
              />
              <el-table-column
                prop="memberRoleDictKeyItemName"
                label="担任角色"
              />
              <el-table-column
                fixed="right"
                label="操作"
                width="150"
                align="center"
              >
                <template slot-scope="scope">
                  <span>
                    <el-button
                      type="text"
                      size="mini"
                      @click.stop="handleSetRole(scope.row)"
                    >
                      指定角色
                    </el-button>
                  </span>
                </template>
              </el-table-column>
            </el-table>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <el-dialog
      title="指定角色"
      :visible.sync="setRoleVisible"
      width="30%"
    >
      <div>
        <el-select
          v-model="memberRowData.memberRoleDictKey"
          filterable
          placeholder="请选择角色"
        >
          <el-option
            v-for="item in getComboxData('D13')"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="setRoleVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveRole">保  存</el-button>
      </span>
    </el-dialog>
    <AddMaster
      v-model="addMasterShow"
      :bumen-name="bumenFullName"
      :danweikey="selectedDanWeiKey"
      :danweibumenkey="memberRowData.data.value"
    />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
import AddMaster from './addMaster'
export default {
  components: {
    AddMaster
  },
  props: {},
  data() {
    return {
      title: '科研团队',
      areaData: [],
      selectedArea: [],
      danweiData: [],
      selectedDanWeiKey: null,
      unitData: [],
      allComboxData: [],
      selectedUnitData: [],
      editFormShow: false,
      entityData: {},
      selectedNodeData: {},
      rules: {
        showName: [{ required: true, message: '请输入科研团队', trigger: 'blur' }]
      },
      memberShow: false,
      memberData: [],
      bumenFullName: '',
      setRoleVisible: false,
      memberRowData: {
        id: null,
        memberRoleDictKey: null,
        node: {},
        data: {}
      },
      addMasterShow: false
    }
  },
  computed: {},
  watch: {},
  created() {
    /** 下拉框数据 */
    pathReq.getComboxDatasByIdArray('D13').then(res => {
      this.allComboxData = res.data.result
    })
  },
  mounted() {
    this.getAreaKey()
  },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    handleSave() {
      const that = this
      if (!this.selectedDanWeiKey) {
        that.$message.error('请选择单位')
        return
      }
      const loading = this.$loading(KxjCom.loadOptions)
      this.$refs.entityData.validate(valid => {
        if (valid) {
          pathReq
            .postForm(
              '/api/services/app/EndUserDanWeiBuMen/CreateOrUpdateEndUserDanWeiBuMen',
              {
                entityData: this.entityData
              }
            )
            .then(() => {
              // 刷新数据
              this.handleGetMainData()
              this.editFormShow = false
              loading.close()
            })
        }
      })
    },
    handleAddLevel1() {
      const that = this
      if (!this.selectedDanWeiKey) {
        this.$message.error('请选择单位')
        return
      }
      this.editFormShow = true
      this.memberShow = false
      const loading = this.$loading(KxjCom.loadOptions)
      pathReq
        .item(
          '/api/services/app/EndUserDanWeiBuMen/GetEditEndUserDanWeiBuMen',
          null
        )
        .then(resp => {
          this.entityData = resp.data.result.entityData
          this.entityData.parentId = null
          this.entityData.danWeiKey = this.selectedDanWeiKey
          this.entityData.parentName = that.danweiData.find(
            x => x.value === that.selectedDanWeiKey
          ).label
          loading.close()
        })
    },
    handleAddNode(node, data) {
      this.editFormShow = true
      this.memberShow = false
      this.selectedNodeData = data
      const loading = this.$loading(KxjCom.loadOptions)
      pathReq
        .item(
          '/api/services/app/EndUserDanWeiBuMen/GetEditEndUserDanWeiBuMen',
          null
        )
        .then(resp => {
          this.entityData = resp.data.result.entityData
          this.entityData.parentName = data.label
          this.entityData.danWeiKey = data.spareStr01
          this.entityData.parentId = data.value
          loading.close()
        })
    },
    handleEditNode(node, data) {
      this.editFormShow = true
      this.memberShow = false
      this.selectedNodeData = data
      const loading = this.$loading(KxjCom.loadOptions)
      pathReq
        .item(
          '/api/services/app/EndUserDanWeiBuMen/GetEditEndUserDanWeiBuMen',
          data.value
        )
        .then(resp => {
          this.entityData = resp.data.result.entityData
          this.entityData.parentName = node.parent.data.label
          this.entityData.danWeiKey = data.spareStr01
          loading.close()
        })
    },
    /** 删除 */
    handleDelNode(data) {
      const loading = this.$loading(KxjCom.loadOptions)
      this.$confirm('是否删除该数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        pathReq
          .dataDelete(
            '/api/services/app/EndUserDanWeiBuMen/DeleteEndUserDanWeiBuMen',
            data.value
          )
          .then(() => {
            // 刷新数据
            this.handleGetMainData()
            loading.close()
          })
      })
    },
    /** 设置负责人 */
    handleAddMaster(node, data) {
      this.memberRowData.data = data
      this.addMasterShow = true
      this.bumenFullName = this.getAllUnitName(node)
    },
    handleViewMember(node, data) {
      this.editFormShow = false
      this.memberShow = true
      this.editFormShow = false
      this.memberShow = true
      this.bumenFullName = this.getAllUnitName(node)
      this.memberRowData.node = node
      this.memberRowData.data = data

      const loading = this.$loading(KxjCom.loadOptions)
      pathReq
        .getForm(
          '/api/services/app/EndUserUnitMember/GetEndUserUnitMembersByBuMenKey',
          { DanWeiBuMenKey: data.value }
        )
        .then(resp => {
          this.memberData = resp.data.result
          loading.close()
        })
    },
    /**
     * 获取地区信息
     */
    getAreaKey() {
      const that = this
      const path =
        '/api/services/app/Combox/GetCascaderDatasById?dictTypeId=D01'
      pathReq.getNoParams(path).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            that.areaData = res.data.result
          }
        }
      })
    },
    handleAreaChange() {
      this.selectedDanWeiKey = null
      this.editFormShow = false
      this.memberShow = false
      this.unitData = []
      pathReq
        .getForm('/api/services/app/Combox/GetDanWeiList', {
          areaId: this.selectedArea.join(',')
        })
        .then(resp => {
          this.danweiData = resp.data.result
        })
    },
    /**
     * 获取单位部门信息
     */
    handleGetMainData() {
      this.editFormShow = false
      this.memberShow = false
      this.unitData = []
      if (!this.selectedDanWeiKey) {
        return
      }
      pathReq
        .getForm('/api/services/app/Combox/GetUnitGroupData', {
          DanWeiKey: this.selectedDanWeiKey
        })
        .then(resp => {
          this.unitData = resp.data.result
        })
    },
    /**
     * 点击设定角色按钮
     */
    handleSetRole(row) {
      this.memberRowData.id = row.id
      this.memberRowData.memberRoleDictKey = row.memberRoleDictKey
      this.setRoleVisible = true
    },
    /**
     * 保存角色
     */
    handleSaveRole() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)
      const path = '/api/services/app/EndUserUnitMember/SetUserRole'
      const p = {
        id: this.memberRowData.id,
        memberRoleDictKey: this.memberRowData.memberRoleDictKey
      }
      pathReq.postForm(path, p).then(res => {
        if (res.status === 200) {
          if (res.data.success) {
            that.handleViewMember(that.memberRowData.node, that.memberRowData.data)
            that.setRoleVisible = false
            loading.close()
          }
        }
      })
    },
    // 取得部门全称
    getAllUnitName(node) {
      var retVal = node.label
      var findParent = function(n) {
        if (n.id && n.level > 0) {
          retVal = n.label + '/' + retVal
          if (n.parent) {
            findParent(n.parent)
          }
        }
      }
      if (node.parent) {
        findParent(node.parent)
      }
      return retVal
    }
  }
}
</script>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
